import React from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import PropTypes from 'prop-types';
import {
    Stack,
    Dialog,
    Text,
    DialogFooter,
    DefaultButton,
    PrimaryButton,
    DialogType,
    BaseButton,
    Button,
} from '@fluentui/react';
import { appStyles, logger } from '../../helpers';
import { Utilities } from '../../helpers';

type Props = {
    hidden?: boolean;
    fileName: string;
    fileNewName: string;
    onDismiss: (dismissed: boolean) => void;
    onOverwrite: (overwrite: boolean) => void;
};

const FileOverwriteDialog = (props: Props) => {
    const uiState = useSelector((state: RootStateOrAny) => state.uiReducer);

    const dialogContentProps = {
        type: DialogType.close,
        title: uiState.translate('overwrite_file_title'),
    };

    const save = async (overwrite: boolean) => {
        logger.info('The action save', 'Dialog');

        props.onDismiss(true);
        props.onOverwrite(overwrite);
    };

    const hideDialog = async (
        e?: React.MouseEvent<HTMLElement | BaseButton | Button>,
    ) => {
        e?.stopPropagation();
        props.onDismiss(true);
    };

    return (
        <Stack>
            <Dialog
                styles={appStyles.DialogStyle}
                hidden={props.hidden}
                onDismiss={hideDialog}
                dialogContentProps={dialogContentProps}
            >
                <Stack tokens={{ childrenGap: 8 }}>
                    <Text className={appStyles.globalStyles.text}>
                        {Utilities.formatString(
                            uiState.translate('overwrite_file'),
                            props.fileName,
                        )}
                    </Text>
                    <Text className={appStyles.globalStyles.text}>
                        {Utilities.formatString(
                            uiState.translate('overwrite_file_keep_both_hint'),
                            props.fileNewName,
                        )}
                    </Text>
                </Stack>
                <DialogFooter>
                    <DefaultButton
                        styles={appStyles.primaryButtonReverse}
                        text={uiState.translate('button_cancel')}
                        onClick={hideDialog}
                    />
                    <DefaultButton
                        styles={appStyles.primaryButtonReverse}
                        text={uiState.translate('button_replace')}
                        onClick={() => save(true)}
                    />
                    <PrimaryButton
                        styles={appStyles.primaryButton}
                        text={uiState.translate('button_keep_both')}
                        onClick={() => save(false)}
                    />
                </DialogFooter>
            </Dialog>
        </Stack>
    );
};

export default FileOverwriteDialog;

FileOverwriteDialog.propTypes = {
    hidden: PropTypes.bool,
    fileName: PropTypes.string,
    fileNewName: PropTypes.string,
    onDismiss: PropTypes.func,
    onOverwrite: PropTypes.func,
};
